import { AjaxError } from "rxjs/ajax";
import { createReducer } from "typesafe-actions";
import { ErrorResponseMessages } from "@/enums/ErrorResponseMessages.enum";
import { ErrorType } from "@/enums/ErrorType.enum";
import { clearError } from "../mode/mode.actions";
import { resetState } from "../root.action";
import { retryableFailures } from "../workspaces/retryableFailures";

export interface ErrorState {
  message: string;
  errorType?: ErrorType;
}

export const defaultState = (): ErrorState => ({
  // TODO: Is this really the default state message that we want when we clear error?
  //       Or does it make more sense for it to be '' or null?
  message: "Something went wrong, our engineers are working on it!",
});

export default createReducer<ErrorState>(defaultState())
  .handleAction(resetState, () => defaultState())
  .handleAction(clearError, () => defaultState())
  .handleAction(retryableFailures, (_state, action) => ({
    message: action.payload.message,
    errorType: toErrorType(action.payload.error),
  }));

function toErrorType(error: Error): ErrorType {
  return redistributeSpecificErrorTypes(error) ?? ErrorType.Generic;
}

function redistributeSpecificErrorTypes(error: Error) {
  if (error instanceof AjaxError) {
    switch (error.status) {
      case 403:
        // "403.*": see DocumentIdServer.kt/throwIfWorkspaceCreateNotAllowed()
        if (String(error.response).includes("403.1")) {
          return ErrorType.CreateBlockedByOrgPolicy;
        }
        break;
      case 402:
        if (
          String(error.response.code).includes(
            ErrorResponseMessages.UserLimitReached,
          )
        ) {
          return ErrorType.CreateBlockedByCreditLimit;
        }
        break;
      default:
        return null;
    }
  }

  return null;
}
